import React from "react";

import { Snackbar } from "@mui/material";

import { DEFAULT_CLIPBOARD_SB_DURATION } from "../../constants/index";

interface CopyToClipboardToastProps {
  open: boolean;
  onClose: () => void;
}

const CopyToClipboardToast = ({ open, onClose }: CopyToClipboardToastProps) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={open}
      onClose={onClose}
      autoHideDuration={DEFAULT_CLIPBOARD_SB_DURATION}
      message="Copied to clipboard!"
    />
  );
};

export default CopyToClipboardToast;
